
import { PropType } from 'vue'
import { IdfBreadcrumb, IdfTextIcon } from '@invivodf/ui-kit'
import { useI18nForVue2 } from '@invivodf/locales/src/useI18n'
import { ImportReport } from '../../domain/ImportReport'
import PImportReportEntry from './PImportReportEntry/PImportReportEntry.vue'

export default {
  components: { PImportReportEntry, IdfBreadcrumb, IdfTextIcon },
  props: {
    error: { required: true, type: String },
    loading: { required: true, type: Boolean },
    importReports: { required: true, type: Array as PropType<ImportReport[]> },
  },
  setup() {
    const i18n = useI18nForVue2()
    const breadcrumbsItems = [
      { label: i18n.t('breadcrumbs.home'), link: { name: 'home' }, icon: 'home-filled' },
      { label: i18n.t('breadcrumbs.parameters'), link: { name: 'parameters' } },
      { label: i18n.t('breadcrumbs.history_import') },
    ]
    return { breadcrumbsItems }
  },
}
